import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, Paper, Button } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import RuleTestingPage from '../../RuleTestingPage';
import { useCustomerDetail } from '../../../hooks/useCustomerDetail';
import { usePageBreadcrumbs } from '../../../hooks/usePageBreadcrumbs';
import LoadingSpinner from '../../shared/LoadingSpinner';
import ErrorAlert from '../../shared/ErrorAlert';

/**
 * RuleTestingView - Wrapper for RuleTestingPage within customer context
 */
const RuleTestingView = () => {
  const { customerId } = useParams();
  const navigate = useNavigate();
  const { customer, loading, error } = useCustomerDetail(customerId);

  const customerLabel = customer?.customerName || 'Loading...';
  usePageBreadcrumbs([
    { label: 'Customers', path: '/customers' },
    { label: customerLabel, path: `/customers/${customerId}`, state: { returnTab: 'augmentation' } },
    { label: 'Rule Testing' }
  ], [customerLabel]);

  const handleBack = () => {
    navigate(`/customers/${customerId}`, { state: { returnTab: 'augmentation' } });
  };

  if (loading) {
    return <LoadingSpinner size="large" />;
  }

  if (error) {
    return <ErrorAlert message={error} onClose={() => navigate('/customers')} />;
  }

  if (!customer) {
    return <ErrorAlert message="Customer not found" onClose={() => navigate('/customers')} />;
  }

  return (
    <div>
      {/* Back Button */}
      <Paper elevation={1} sx={{ p: 2, mb: 2 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Button
            variant="outlined"
            size="small"
            startIcon={<ArrowBack />}
            onClick={handleBack}
            aria-label="Back to customer detail"
          >
            Back to Customer
          </Button>
        </Box>
      </Paper>

      {/* Rule Testing Content */}
      <RuleTestingPage customerId={customerId} />
    </div>
  );
};

export default RuleTestingView;
